"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ArrowBack = function () { return (react_1.default.createElement("svg", { width: "17", height: "16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M16 7a1 1 0 110 2V7zM.293 8.707a1 1 0 010-1.414L6.657.929A1 1 0 018.07 2.343L2.414 8l5.657 5.657a1 1 0 11-1.414 1.414L.293 8.707zM16 9H1V7h15v2z", fill: "#292827" }))); };
exports.default = ArrowBack;
//# sourceMappingURL=ArrowBack.js.map